/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_LegalInputs */

const en_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Information`)
};

const lv_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekvizīti`)
};

/**
* | output |
* | --- |
* | "Legal Information" |
*
* @param {Footer_LegalInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_legal = /** @type {((inputs?: Footer_LegalInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_LegalInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_legal(inputs)
	return en_footer_legal(inputs)
});